import { Button, Message } from '@alifd/next';
import moment from 'moment';
import React, { useContext } from 'react';

import { BackStageContext } from '@/contexts/BackStageContext';
import client from '@/lib/feathers';
import { deleteFile } from '@/lib/manipulateFile';

export default function DeleteButton({
  dbName,
  defaultValue,
  setIsUpdate,
  func,
}) {
  const { setBackStageUpdateTrigger } = useContext(BackStageContext);
  const handleRemove = async () => {
    try {
      if (func.deleteStatus) {
        await client.service(dbName).patch(defaultValue._id, {
          ...defaultValue,
          activated: !defaultValue.activated,
          endDate: moment().valueOf(),
        });
      } else {
        await client.service(dbName).remove(defaultValue._id);
      }
      const files = [];
      Object.entries(defaultValue).forEach(([key, value]) => {
        if (['licenses', 'logo', 'contractFile'].includes(key)) {
          files.push(...value);
        }
      });
      await Promise.all(files.map((file) => deleteFile(file)));
      Message.success(
        func.deleteStatus
          ? defaultValue.activated
            ? '停用成功'
            : '啟用成功'
          : '刪除成功'
      );
      setIsUpdate(true);
      setBackStageUpdateTrigger({});
    } catch (e) {
      console.log(e);
      Message.error('發生錯誤');
    }
  };

  return (
    <Button type="normal" warning onClick={handleRemove}>
      {func.deleteStatus ? (defaultValue.activated ? '停用' : '啟用') : '刪除'}
    </Button>
  );
}
